// extracted by mini-css-extract-plugin
export default {"addressDetails":"AddressDetails_addressDetails__WSBN6","formSpace":"AddressDetails_formSpace__EqBtu"};